<template>
    <b-form @submit.stop.prevent="saveAfterSale" novalidate="novalidate" autocomplete="off">
        <div class="row">
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="client" class="bmd-label-floating">Cliente:</label>
                    <input refs="client" type="text" class="form-control" v-model="after_sale.client.name" disabled="" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="after_sale" class="bmd-label-floating">Contrato:</label>
                    <input refs="after_sale" type="text" class="form-control" v-model="after_sale.physical_proposal" disabled="" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="representative_id" class="bmd-label-floating">Grupo / Cota:</label>
                    <input refs="group_quota" type="text" class="form-control" v-model="after_sale.group + ' / ' + after_sale.quota" disabled="" />
                </div>
            </div>
        </div>
        <br />
        <h5>Dados de Contato:</h5>
        <hr />
        <div class="row">
            <div class="col-md-4">
                <h6 class="card-title">Telefone Celular</h6>
                <p class="card-category">{{ after_sale.client.cell_phone | phone }}</p>
            </div>
            <div class="col-md-4">
                <h6 class="card-title">Telefone Comercial</h6>
                <p class="card-category">{{ after_sale.client.commercial_phone | phone }}</p>
            </div>
            <div class="col-md-4">
                <h6 class="card-title">E-mail</h6>
                <p class="card-category">{{ after_sale.client.mail }}</p>
            </div>
        </div>
        <br />
        <h5 >Dados de endereço:</h5>
        <hr />
        <div class="row">
            <div class="col-md-4">
                <h6 class="card-title">CEP</h6>
                <p class="card-category">{{ after_sale.client_address.cep | cep }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <h6 class="card-title">Endereço</h6>
                <p class="card-category">{{ after_sale.client_address.address }}</p>
            </div>
            <div class="col-md-2">
                <h6 class="card-title">Número</h6>
                <p class="card-category">{{ after_sale.client_address.number }}</p>
            </div>
            <div class="col-md-4">
                <h6 class="card-title">Bairro</h6>
                <p class="card-category">{{ after_sale.client_address.borough }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <h6 class="card-title">Complemento</h6>
                <p class="card-category">{{ after_sale.client_address.complement }}</p>
            </div>
            <div class="col-md-6">
                <h6 class="card-title">Cidade</h6>
                <p class="card-category">{{ after_sale.client_address.city.name }}/{{ after_sale.client_address.city.state.abbreviation }}</p>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled"
                    v-bind:class="{'has-danger': validation.representative_id != '' }">
                    <label for="representative_id" class="bmd-label-floating">Representante <span class="text-danger">*</span></label>
                    <model-list-select 
                        class="form-control"
                        :list="representatives"     
                        option-value="id"
                        option-text="name"
                        v-model="form.representative_id"
                        :isDisabled="!canEditData">
                    </model-list-select>
                    <label v-if="validation.representative_id != ''" class="error" for="representative_id">{{ validation.representative_id }}</label>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled"
                    v-bind:class="{'has-danger': validation.status_id != '' }">
                    <label for="status_id" class="bmd-label-floating">Status <span class="text-danger">*</span></label>
                    <model-list-select 
                        class="form-control"
                        :list="after_sale_statuses"     
                        option-value="id"
                        option-text="status"
                        v-model="form.status_id"
                        :isDisabled="!canEditData">
                    </model-list-select>
                    <label v-if="validation.status_id != ''" class="error" for="status_id">{{ validation.status_id }}</label>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled"
                    v-bind:class="{'has-danger': validation.situation != '' }">
                    <label for="situation" class="bmd-label-floating">Situação <span class="text-danger">*</span></label>
                    <model-list-select 
                        class="form-control"
                        :list="situations"     
                        option-value="id"
                        option-text="name"
                        v-model="form.situation"
                        :isDisabled="!canEditSituatio">
                    </model-list-select>
                    <label v-if="validation.situation != ''" class="error" for="situation">{{ validation.situation }}</label>
                </div>
            </div>
        </div>
        <div class="row" v-if="isAdmin()">
            <div class="col-12">
                <div class="form-group bmd-form-group is-filled">
                    <label for="private_observation" class="bmd-label-floating">Observação Privada</label>
                    <b-form-textarea
                        data-vv-name="private_observation"
                        id="private_observation"
                        v-model="form.private_observation"
                    ></b-form-textarea>
                    <small class="text-info">Essa observação só será visualizada pelos administradores</small>
                </div>
            </div>
        </div>
        <hr />
        <h5 v-if="after_sale.after_sale_remarkers.length > 0">Interações:</h5>
        <div class="row" v-for="iterator in after_sale.after_sale_remarkers">
            <div class="col-4">
                <div class="form-group bmd-form-group">
                    <label>
                        <strong>De:</strong><br />
                        {{ iterator.source_user.name }}
                    </label>
                </div>
            </div>
            <div class="col-8">
                <div class="form-group bmd-form-group">
                    <label>
                        <strong>Mensagem:</strong><br />
                        {{  iterator.text ? iterator.text : '--' }}<br />
                        <small>({{ iterator.created_at | moment("DD/MM/YYYY") }} às {{ iterator.created_at | moment('add', '3 hours') | moment('HH:mm') }})</small>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div
                class="form-group bmd-form-group"
                :class="{'is-filled': !!form.text, 'has-danger': validation.text != '' }"
                >
                    <label for="text" class="bmd-label-floating">Mensagem</label>
                    <b-form-textarea
                        data-vv-name="text"
                        v-validate="validation.text"
                        id="text"
                        v-model="form.text"
                    ></b-form-textarea>
                    <label v-if="validation.text != ''" class="error" for="text">{{ validation.text }}</label>
                </div>
            </div>
        </div>

        <b-button :disabled="loading" type="submit" variant="primary">Salvar</b-button>
    </b-form>
</template>

<script>
import 'moment'

export default {
    $_veeValidate: {
        validator: "after_sale_update" // give me my own validator scope.
    },
    computed: {
        after_sale: {
            set(after_sale) {},
            get() {
                this.form.id = this.$store.state.after_sales.item.id;
                this.form.situation = this.$store.state.after_sales.item.situation;
                this.form.status_id = this.$store.state.after_sales.item.status_id;
                this.form.representative_id = this.$store.state.after_sales.item.representative_id;
                this.form.private_observation = this.$store.state.after_sales.item.private_observation;
                return this.$store.state.after_sales.item;
            }
        },
        after_sale_statuses: {
            set(after_sale_statuses) {},
            get() {
                return this.$store.state.after_sale_status.itens.filter(item => !item.auto_finish)
            }
        },
        representatives: {
            set(representatives) {},
            get() {
                return this.$store.state.users.itens
            }
        }
    },
    data() {
        return {
            canEditData: this.$store.state.auth.user.profile.type_profile_id <= 3,
            canEditSituatio: this.$store.state.auth.user.profile.type_profile_id <= 4,
            form: {
                id: "",
                status_id: "",
                representative_id: "",
                situation: "",
                private_observation: "",
                text: ""
            },
            loading: false,
            situations: [
                {
                    id: "A",
                    name: "Alocada"
                },
                {
                    id: "C",
                    name: "Cancelada"
                },
                {
                    id: "N",
                    name: "Não alocada"
                }
            ],
            validation: {
                status_id: '',
                representative_id: '',
                situation: '',
                text: ''
            }
        };
    },
    created() {
        this.getContract();
    },
    methods: {
        async getContract() {
            this.$root.$emit("onLoading");

            await this.$store.dispatch(
                "after_sales/get",
                this.$route.params.id
            );

            await this.$store.dispatch(
                "after_sale_status/all"
            )

            await this.$store.dispatch("users/all", 'type_profile_id=4&branch_id=' + this.$store.state.auth.user.branch_id);

            this.$root.$emit("onLoading");
        },
        isAdmin() {
            return this.$store.state.auth.user.profile.type_profile_id == 1
        },
        async saveAfterSale() {
            var self = this;
            var valid = true;
            self.validation = {
                status_id: '',
                representative_id: '',
                situation: '',
                text: ''
            }

            if (self.form.status_id == "" || self.form.status_id == null) {
                self.validation.status_id = 'Campo obrigatório!';
                valid = false;
            }
            if (self.form.representative_id == "" || self.form.representative_id == null) {
                self.validation.representative_id = 'Campo obrigatório!';
                valid = false;
            }
            if (self.form.situation == "" || self.form.situation == null) {
                self.validation.situation = 'Campo obrigatório!';
                valid = false;
            }
            
            // if (self.form.text == "" || self.form.text == null) {
            //     self.validation.text = 'Campo obrigatório!';
            //     valid = false;
            // }

            if (valid){
                self.loading = true;
                self.$root.$emit('onLoading');

                var response = await self.$store.dispatch(
                    "after_sales/edit",
                    self.form
                )
            
                this.loading = false;
                this.$root.$emit("updateList");
                this.$root.$emit("hideModal");
                this.$notify.success('Pós venda atualizada com sucesso');
                this.$root.$emit("onLoading");
            }
        },
    }
};
</script>